export const init = () => {
    const observer = new MutationObserver(mutationHandler);
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    function mutationHandler() {
        const containers = document.querySelectorAll('.js-lazy-loading-carousel');
        containers.forEach(initCarousel);
    }

    function initCarousel(container) {
        const activeSlides = container.querySelectorAll('.splide__slide.is-visible');
        activeSlides.forEach(initSlide);

        const slideObserver = new MutationObserver(() => {
            const activeSlides = container.querySelectorAll('.splide__slide.is-next');
            activeSlides.forEach(initSlide);
        });

        activeSlides.forEach(slide => {
            slideObserver.observe(slide, {
                attributes: true,
                attributeFilter: ['class']
            });
        });
    }

    function initSlide(slide) {
        const items = slide.querySelectorAll('img[data-src]');
        dataToSrc(items);
        let loadedCount = 0;
        
        const onLoad = () => {
            loadedCount++;
            if (loadedCount === items.length) {
                slide.querySelector('.loader')?.classList.remove('active');
            }
        };
    
        items.forEach(img => {
            if (img.complete) {
                onLoad();
            } else {
                img.addEventListener('load', onLoad);
            }
        });
    }

    function dataToSrc(items) {
        items.forEach(img => {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
        });
    }
};